/**
 * Gutenberg Block JS
 *
 * Import JS for Gutenberg blocks.
 */
import './custom/block-testimonials';
